import React from "react";
import { Typography, Stack } from "@mui/material";
import { useFormikContext } from "formik";
import DropzoneField from "../services/DropzoneField";
import FormHelperText from "@mui/material/FormHelperText";

const MediaUploadSection = ({ handleMediaUpload }) => {
  const { setFieldValue, errors, touched } = useFormikContext();

  return (
    <>
      <Typography variant="h6" mt={4} gutterBottom>
        Media Uploads
      </Typography>

      <Stack spacing={2}>
        <Typography variant="body2" color="textSecondary" mt={2}>
          Upload up to <strong>10 images</strong> for your tour. The images will
          give potential travelers a visual preview of your tour and its
          attractions.
          <br />
          • Allowed formats: JPG, PNG, WEBP <br />• Max file size: 3MB per image
        </Typography>
        <DropzoneField
          label="Tour Images"
          fieldName="media.tourImages"
          acceptedTypes={["image/jpeg", "image/png", "image/webp"]}
          setFieldValue={setFieldValue}
          uploadHandler={handleMediaUpload}
        />
        {touched?.media?.tourImages && errors?.media?.tourImages && (
          <FormHelperText error>{errors.media.tourImages}</FormHelperText>
        )}

        <Typography variant="body2" color="textSecondary" mt={4}>
          Upload up to <strong>2 videos</strong> showcasing your tour
          experience. Videos can help convey the atmosphere and highlight the
          most exciting parts of your tour.
          <br />
          • Allowed formats: MP4, WEBM <br />• Max file size: 5MB per video
        </Typography>
        <DropzoneField
          label="Tour Videos"
          fieldName="media.tourVideos"
          acceptedTypes={["video/mp4", "video/webm"]}
          setFieldValue={setFieldValue}
          uploadHandler={handleMediaUpload}
        />

        <Typography variant="body2" color="textSecondary" mt={4}>
          Upload up to <strong>4 additional files</strong>. These files can
          include brochures, manuals, magazines, or other documents that provide
          detailed information about your tour.
          <br />
          • Allowed formats: PDF, DOCX <br />• Max file size: 3MB per file
        </Typography>
        <DropzoneField
          label="Additional Files"
          fieldName="media.additionalFiles"
          acceptedTypes={[
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ]}
          setFieldValue={setFieldValue}
          uploadHandler={handleMediaUpload}
        />
      </Stack>
    </>
  );
};

export default MediaUploadSection;
